import { Component, inject } from '@angular/core';
import { VexPopoverRef } from '@vex/components/vex-popover/vex-popover-ref';
import { MatRippleModule } from '@angular/material/core';
import { Router, RouterLink } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { CognitoService } from '@shared/angular/cognito';
import { CurrentUserModel } from '@shared/common/models';
import { environment } from '../../../../../../environments/environment';

@Component({
    templateUrl: './toolbar-user-menu.component.html',
    styleUrls: ['./toolbar-user-menu.component.scss'],
    imports: [MatRippleModule, RouterLink, MatIconModule],
    standalone: true,
})
export class SidenavUserMenuComponent {
    private cognitoService = inject(CognitoService);
    public currentUser = inject(CurrentUserModel);
    public router = inject(Router);
    public routes = environment.routes;
    constructor(private readonly popoverRef: VexPopoverRef) {}

    close(): void {
        /** Wait for animation to complete and then close */
        setTimeout(() => this.popoverRef.close(), 250);
    }

    public logout() {
        this.cognitoService.signOut().subscribe(() => {
            localStorage.clear();
            this.popoverRef.close();
            this.router.navigate([this.routes.login]);
        });
    }
}
